export default "__VITE_ASSET__tE$L3t_L__"